var _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _path4, _circle5, _circle6, _circle7, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBandwidthLatencyOptimizationinline = function SvgBandwidthLatencyOptimizationinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#D1D7E0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M40 40 22.293 22.293a1 1 0 0 1-.293-.707V13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D1D7E0",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M10 40h17M55 40h15"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D1D7E0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M40 40 22.293 57.707a1 1 0 0 0-.293.707V67"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    fill: "#D6EBFF",
    stroke: "#0073E6",
    strokeLinejoin: "round",
    strokeWidth: 2,
    transform: "matrix(1 0 0 -1 17 18)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 67,
    r: 5,
    fill: "#FFF5D6",
    stroke: "#FFBF00",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 40,
    r: 5,
    fill: "#fff",
    stroke: "#A7B1BE",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 40,
    r: 5,
    fill: "#fff",
    stroke: "#A7B1BE",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D1D7E0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m40 40 17.707-17.707a1 1 0 0 0 .293-.707V13M40 40l17.707 17.707a1 1 0 0 1 .293.707V67"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 13,
    r: 5,
    fill: "#FBDADA",
    stroke: "#EB4748",
    strokeWidth: 2,
    transform: "rotate(180 58 13)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    fill: "#D6EBFF",
    stroke: "#0073E6",
    strokeLinejoin: "round",
    strokeWidth: 2,
    transform: "matrix(-1 0 0 1 63 62)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 14,
    fill: "#D6FFFC",
    stroke: "#00877C",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00877C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M45.66 45C47.105 43.62 48 41.717 48 39.615 48 35.41 44.418 32 40 32s-8 3.41-8 7.616c0 2.102.895 4.006 2.342 5.384"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#00877C",
    d: "M46.225 32.007a1.158 1.158 0 0 1 1.62 1.62l-5.81 7.815a2.59 2.59 0 1 1-3.625-3.625l7.815-5.81"
  })));
};
export default SvgBandwidthLatencyOptimizationinline;